import React, { useMemo, useState } from 'react';
import { colorPaletteOptions } from '../../../core/globalVariables.js';
import {
  fmesh
} from '../../../core/globalVariables.js';

const RenderedPTags = ({
  selectedLandTypes,
  handleLandtypePTagClick,
  universalParcelDifferentiator,
  selectedYearEditing,
  longstandingGeoJSONRef,
  universalColorPaletteName,
  landKeySelectedKey,
  setLandKeySelectedKey,
  universalDataLoaded,
  activeLayer
}) => {
  const [selectedKey, setSelectedKey] = useState('');

  const geojson = longstandingGeoJSONRef.current;

  // Extract keys dynamically from GeoJSON
  const availableKeys = useMemo(() => {
    try {
      if (!geojson || !geojson.features) return [];

      return Array.from(
        new Set(
          geojson.features.flatMap((feature) =>
            Object.keys(feature.feature_data_simple_timeseries || {})
          )
        )
      );
    } catch (error) {
      console.error('Error extracting keys from GeoJSON:', error);
      return [];
    }
  }, [geojson, activeLayer]);

  // Memoize the color map to avoid recalculating on every render
  const differentiatorColorMap = useMemo(() => {
    try {
      const timeSeriesArray = [];

      fmesh.traverse((child) => {
        if (child.isMesh) {
          for (let i = 0; i < geojson.features.length; i++) {
            if (child.name === geojson.features[i].skylark_id) {
              const timeSeriesData = geojson.features[i].feature_data_simple_timeseries[landKeySelectedKey]?.[selectedYearEditing];
              if (timeSeriesData) {
                const r = Math.round(child.material.color.r * 255);
                const g = Math.round(child.material.color.g * 255);
                const b = Math.round(child.material.color.b * 255);
                const hexColor = `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
                const uniqueEntry = { timeSeriesData, color: hexColor };

                if (!timeSeriesArray.some(entry => entry.timeSeriesData === uniqueEntry.timeSeriesData && entry.color === uniqueEntry.color)) {
                  timeSeriesArray.push(uniqueEntry);
                }
              }
            }
          }
        }
      });

      const differentiatorColorMap = {};

      if (!geojson || !geojson.features || !landKeySelectedKey) return {};

      geojson.features.forEach((feature) => {
        const key = feature.feature_data_simple_timeseries[landKeySelectedKey]?.[selectedYearEditing];

        if (key) {
          const colorEntry = timeSeriesArray.find(entry => entry.timeSeriesData === key);
          differentiatorColorMap[key] = colorEntry ? colorEntry.color : 'transparent';
        }
      });

      return differentiatorColorMap;
    } catch (error) {
      console.error('Error memoizing color map:', error);
      return {};
    }
  }, [geojson, landKeySelectedKey, selectedYearEditing, universalDataLoaded, activeLayer]);

  const capitalizeWords = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <>
      <div>
        {/* Buttons for Reset and Hide All */}
      </div>

      <div
        className="ResetLandtypeListButton"
        onClick={() => handleLandtypePTagClick('Reset')}
      >
        Reset
      </div>
      <div
        className="HideAllLandtypeListButton"
        onClick={() => handleLandtypePTagClick('Hide all')}
      >
        Hide all
      </div>
      <div className="land_types_accum_landkey">
  {Object.keys(differentiatorColorMap)
    // 👇 Sort alphabetically (numbers first, then a–z)
    .sort((a, b) => {
      const aNum = /^\d/.test(a);
      const bNum = /^\d/.test(b);
      if (aNum && !bNum) return -1;
      if (!aNum && bNum) return 1;
      return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
    })
    .map((item) => {
      const isSelected = selectedLandTypes.includes(item);
      const backgroundColor = differentiatorColorMap[item] || 'transparent';

      const truncatedItem =
        item.length > 30 ? `${item.substring(0, 30)}...` : item;
      const capitalizedTruncatedItem = capitalizeWords(truncatedItem);

      return (
        <div
          key={item}
          className={`land_type_list_general_p ${isSelected ? 'selectedLandType' : ''}`}
          onClick={() => handleLandtypePTagClick(item, landKeySelectedKey)}
        >
          <span
            className="color_circle"
            style={{ backgroundColor }}
          ></span>
          <div className="land_type_item_text">
            <p className="land_type_item_key">{capitalizedTruncatedItem}</p>
          </div>
        </div>
      );
    })}
</div>

    </>
  );
};

export default RenderedPTags;
